import { QueryClient } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { CompanyDto } from "#modules/company/infra/Company.dto";
import { fetchCompany } from "#modules/company/infra/fetchCompany.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { QueryOptions } from "#types/QueryOptions";

export const companyQuery = (): QueryOptions<CompanyDto | null> => ({
  queryKey: queryKeys.company.mine,
  queryFn: () => fetchCompany(),
  staleTime: STALE_TIME,
});

export const getCompanyQueryData = (queryClient: QueryClient): CompanyDto | null | undefined => {
  return queryClient.getQueryData<CompanyDto | null>(queryKeys.company.mine);
};

type CompanyQueryDataUpdater =
  | CompanyDto
  | null
  | undefined
  | ((old: CompanyDto | null | undefined) => CompanyDto | null | undefined);

export const setCompanyQueryData = (
  queryClient: QueryClient,
  updater: CompanyQueryDataUpdater,
): CompanyDto | null | undefined => {
  return queryClient.setQueryData<CompanyDto | null>(queryKeys.company.mine, updater);
};
